import { Toast as BaseToast } from '@base-ui/react/toast'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ToastViewportProps extends PartProps<BaseToast.Viewport.Props> {
  className?: string
}

/**
 * Bottom centre, clear of the safe area. Every toast shares its one grid cell, so a newer toast covers an
 * older one in place, each at its own height on the cell's bottom edge, so a taller toast waiting underneath
 * never stretches the one showing. It never takes the pointer; the toasts do, so an action works.
 */
function ToastViewport({ className, ...props }: ToastViewportProps) {
  return (
    <BaseToast.Viewport
      className={twMerge(
        'pointer-events-none fixed inset-x-0 bottom-[calc(24px+env(safe-area-inset-bottom))] z-40 grid items-end justify-items-center',
        className,
      )}
      {...props}
    />
  )
}

export type { ToastViewportProps }
export { ToastViewport }
